module.exports = __webpack_public_path__ + "8e917a7e08dc97b24342890418c58ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/poslogo_blue.png
// module id = 483
// module chunks = 0